import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardTitle, CardContent } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import userApi from '../../api/userApi';
import { toast } from 'react-toastify';

const ChangeMobile = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [newMobile, setNewMobile] = useState(localStorage.getItem("mobile") || "");

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!newMobile.trim()) {
            toast.error(t('common.mobile_change_failed'));
            return;
        }

        setLoading(true);
        try {
            const response = await userApi.changeMobile({
                newMobile: newMobile
            });
            toast.success(t('common.mobile_changed_success'));
            localStorage.setItem("mobile", response.data.mobile);
            // Optional: redirect or stay on page
        } catch (error) {
            toast.error(error.response?.data?.message || t('common.mobile_change_failed'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-[400px]">
            <Card className="w-full max-w-md">
                <CardHeader>
                    <CardTitle className="text-center">{t('common.change_mobile')}</CardTitle>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="newMobile">{t('common.new_mobile')}</Label>
                            <Input
                                id="newMobile"
                                type="text"
                                value={newMobile}
                                onChange={(e) => setNewMobile(e.target.value)}
                                required
                            />
                        </div>
                        <Button type="submit" className="w-full" disabled={loading}>
                            {loading ? t('common.saving') : t('common.save')}
                        </Button>
                    </form>
                </CardContent>
            </Card>
        </div>
    );
};

export default ChangeMobile;
